import React, { Component } from 'react';

export class Duration extends Component {

    handleDurationChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        this.props.specificChanges(name, value);
    }

    render() {
        return (
            <div className="form-horizontal row spacer">
                <label className="control-label col-sm-4" htmlFor="Duration">How long did the incident(s) last?</label>
                <div className="col-sm-8">
                    <input className="form-control" type="text" name="duration" onBlur={this.handleDurationChange} placeholder="e.g. 2 hours" maxLength={100}/>
                </div>
            </div >
        );
    }
}
export default Duration;



// WEBPACK FOOTER //
// ./src/components/questions/Duration.jsx